import React, { HTMLProps } from 'react';
import PhoneInput from 'react-phone-input-2';
import cn from 'classnames';

import 'react-phone-input-2/lib/style.css';

import './PhoneInputField.scss';

interface PhoneInputFieldProps extends Omit<HTMLProps<HTMLInputElement>, 'onChange'> {
  buttonStyle?: any;
  onChange: (value: any, data: any, event: any, formattedValue: any) => void;
  initialCountry: string;
  countries: string[];
  isValid?: boolean;
}
const PhoneInputField: React.FC<PhoneInputFieldProps> = ({
  value,
  onChange,
  style,
  placeholder,
  className,
  buttonStyle,
  disabled,
  initialCountry,
  countries,
  isValid,
}) => (
  <div style={style} className={cn(className, 'phone-input-field')}>
    <PhoneInput
      value={value as any}
      placeholder={placeholder}
      country={initialCountry}
      countryCodeEditable={false}
      onlyCountries={countries}
      // enableLongNumbers
      inputStyle={{
        fontFamily: 'Catamaran',
        fontSize: 20,
        border: 0,
        borderBottom: '2px solid #ecebeb',
        width: '100%',
        borderRadius: 0,
        color: '#757575',
      }}
      // autoFormat
      dropdownStyle={{
        fontFamily: 'Catamaran',
        fontSize: 18,
      }}
      isValid={isValid}
      buttonStyle={{
        border: 0,
        background: 'none',
        ...buttonStyle,
      }}
      onChange={onChange}
      disabled={disabled}
    />
  </div>
);

export default PhoneInputField;
